// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"add-criteria-position-form_wrapper__RaHPF","title":"add-criteria-position-form_title__1jj-b","positionName":"add-criteria-position-form_positionName__1s3M3"};